import React, { useCallback, useEffect } from 'react';

import CSSModule from 'react-css-modules';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { BusinessInfoTile, Spinner } from 'components';
import { actions } from 'coupon-common/src/modules/businesses/all';

import { RouteNames } from '../../../constants';
import styles from './BusinessesListSearch.module.scss';

const BusinessesListSearch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const allState = useSelector(state => state.businesses.all);
  const { fetching, fetched, data, error } = allState;
  const { results: list, nextPage } = data || { results: [] };

  const getAllList = useCallback(
    params => {
      dispatch(actions.getAllList(params));
    },
    [dispatch],
  );

  useEffect(() => {
    getAllList();
  }, [getAllList]);

  const goToDetails = id => navigate(`${RouteNames.BUSINESSES_DETAILS}/${id}`);

  const handleLoadMore = () => {
    if (nextPage) {
      getAllList({ page: nextPage });
    }
  };

  return (
    <div styleName="page">
      <div styleName="wrap">
        {error && <p styleName="state-message">Something went wrong loading businesses.</p>}

        {!error && !fetched && fetching && (
          <div styleName="state-message">
            <Spinner show size="md" />
          </div>
        )}

        {!error && (!list || list.length === 0) && fetched && <p styleName="state-message">No businesses found.</p>}

        {!error && list && list.length > 0 && (
          <>
            <div styleName="list">
              {list.map((item, index) => (
                <BusinessInfoTile key={item.id} first={index === 0} data={item} onPress={() => goToDetails(item.id)} />
              ))}
            </div>
            {nextPage && (
              <div styleName="load-more-row">
                <button type="button" styleName="load-more-btn" onClick={handleLoadMore} disabled={fetching}>
                  {fetching ? <Spinner show size="sm" /> : 'Load more'}
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CSSModule(BusinessesListSearch, styles, { allowMultiple: true });
